var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudentContractManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 18.5 19.653",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-220.5 -256.486)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5f5f5f",
    d: "M236,268.4l-.946,3.288-.449-2.344.418-.944h-1.389l.419.944-.45,2.344-.945-3.288-2.324.854c-.164.409-.679,3.752-.679,3.752a25.144,25.144,0,0,0,4.674.52,16.574,16.574,0,0,0,4.674-.52s-.514-3.343-.68-3.752Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5f5f5f",
    d: "M232.654,265.981c.3.9.822,1.518,1.673,1.518s1.375-.618,1.674-1.518c.26.021.443-.28.562-.676.182-.6-.012-.818-.271-.892V264.4h0a3.865,3.865,0,0,0-.055-1.335.441.441,0,0,0-.359-.339,1.864,1.864,0,0,0-1.283-.74c-1.743-.412-1.764.7-1.764.7h0a.387.387,0,0,0-.471.393,9.406,9.406,0,0,0,0,1.322h0v.014c-.26.076-.454.291-.271.892C232.211,265.7,232.393,266,232.654,265.981Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5f5f5f",
    d: "M233.676,274.01h1.42v1.6a.89.89,0,0,1-.444.532H220.988a.791.791,0,0,1-.488-.577V257.018a.521.521,0,0,1,.532-.532h10.914l3.106,2.928v2.218a2.376,2.376,0,0,0-1.331-.266v-.888h-2.4s-.266-.088-.266-.266v-2.4H221.92v16.947h11.712v-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5f5f5f",
    d: "M224.366,264.2l-.436-.581.436-.436.581.436,1.307-.436.145-.872h.436l.145.872,1.162.581.872-.581.291.291-.436.872.436,1.162.872.145v.436l-.872.145-.436,1.162.436.872-.291.291-.726-.436-1.307.581-.145.872H226.4l-.291-.872-1.162-.581-.726.436-.291-.291.436-.726-.436-1.162-.872-.145V265.8l.726-.145.581-1.453"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    fill: "#fff",
    cx: 1.743,
    cy: 1.743,
    r: 1.743,
    transform: "translate(224.802 264.198)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    fill: "#5f5f5f",
    cx: 0.872,
    cy: 0.872,
    r: 0.872,
    transform: "translate(225.673 265.07)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentContractManagement);
export default __webpack_public_path__ + "static/media/StudentContractManagement.fd97d56d2c0408a7a0eb20618d326c14.svg";
export { ForwardRef as ReactComponent };